import { heroStats, heroTags } from "@/mocks/home";

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full">
      <div className="relative flex min-h-[600px] w-full items-center overflow-hidden md:min-h-[720px]">
        <div className="absolute inset-0 h-full w-full">
          <img
            src="https://readdy.ai/api/search-image?query=dark%20cinematic%20abstract%20visualization%20of%20encrypted%20data%20streams%20and%20tangled%20surveillance%20wires%20drifting%20over%20a%20shadowy%20city%20grid%20deep%20charcoal%20background%20with%20crimson%20and%20amber%20light%20leaks%20mysterious%20investigative%20mood%20high%20contrast%20atmospheric%20fog%20no%20text&width=1600&height=900&seq=hw-hero-072&orientation=landscape"
            alt="黑网爆料专题合集主视觉：暗色数据流与线索网络"
            title="黑网爆料 黑灰产 黑色产业链 暗黑交易 地下市场 黑市信息"
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/65 to-foreground-950/90"></div>
        </div>

        <div className="relative z-10 mx-auto w-full max-w-[1400px] px-4 py-24 md:px-6 md:py-32 lg:px-10">
          <div className="mx-auto flex w-full max-w-4xl flex-col items-center text-center">
            <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-foreground-950/40 px-4 py-1.5 text-xs tracking-[0.28em] text-background-100">
              <span className="h-1.5 w-1.5 animate-hw-pulse rounded-full bg-primary-400"></span>
              专题合集 · 第 072 期
            </span>

            <h2 className="mt-7 font-heading text-3xl leading-[1.25] text-background-50 md:text-5xl lg:text-[3.6rem] lg:leading-[1.2]">
              穿透迷雾
              <span className="mx-2 text-primary-400">·</span>
              看清黑产如何运转
            </h2>

            <p className="mt-6 max-w-2xl text-sm leading-8 text-background-200 md:text-base md:leading-9">
              黑网爆料专注深挖黑灰产与黑色产业链，持续曝光暗黑交易、地下市场与黑市信息。
              这里汇集多方线报与实锤材料，帮你一眼看清黑产运作逻辑，掌握一手风险预警。
            </p>

            <div className="mt-9 flex w-full flex-col items-center justify-center gap-3 sm:w-auto sm:flex-row">
              <a
                href="#topics"
                className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
              >
                <i className="ri-layout-masonry-line text-base"></i>
                进入专题合集
              </a>
              <a
                href="#desk"
                className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10 sm:w-auto"
              >
                <i className="ri-shield-keyhole-line text-base"></i>
                匿名投递线报
              </a>
            </div>

            <div className="mt-10 flex flex-wrap items-center justify-center gap-2">
              {heroTags.map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-background-50/20 px-3 py-1 text-xs text-background-200"
                >
                  #{tag}
                </span>
              ))}
            </div>
          </div>

          <div className="mx-auto mt-16 w-full max-w-4xl border-t border-background-50/15 pt-8 md:mt-20">
            <dl className="grid grid-cols-2 gap-6 md:grid-cols-4">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <dt className="font-heading text-2xl text-background-50 md:text-3xl">
                    {stat.value}
                  </dt>
                  <dd className="mt-2 text-xs tracking-wide text-background-300">
                    {stat.label}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}